const getLocalCikkcsoports = (state) => state.cikkcsoports;

export default {
  getLocalCikkcsoports,
};
